import "./pt-logic-delay-true.css"
import { getModelFromInputAtPosition } from '../../common/getModelFunctions';

export default {
	model: {
		active: {
			default: false
		},
		value: {
			default: false
		}
	},
	computed: {
		input_value() {
			const inputs = this.$el.dataset.inputs.split(',');

			return getModelFromInputAtPosition(this.$model, inputs, 0);
		}
	},
	watch: {
		input_value() {
			const blockData = this.$model[this.$el.id];
			const time = parseInt(this.$el.dataset.time || 3);
			if (blockData.active) {
				clearTimeout(blockData.active);
				blockData.active = false;
			} else {
				if (blockData.input_value) {
					blockData.active = setTimeout(function () {
						blockData.active = false;
						blockData.value = true;
					}, time * 1000);
				} else {
					blockData.value = false;
				}
			}
		}
	},
	listeners: {
		click: true
	}
};

